'use strict';

var exports = $.extend({}, require('core/product/detail'));
var toastHelpers = require('core/components/toast');

/**
 * shows toast message
 * @param {string} data - data returned from the server's ajax call
 */
 function displayMessage(data) {
    $.spinner().stop();
    var status = data.success ? 'alert-success' : 'alert-danger';

    if ($('.add-to-wishlist-messages').length === 0) {
        $('body').append('<div class="add-to-wishlist-messages"></div>');
    }

    $('.add-to-wishlist-messages').append('<div class="alert text-center add-to-wishlist-alert text-center ' + status + '">' + data.msg + '</div>');

    setTimeout(function () {
        $('.add-to-wishlist-messages').remove();
    }, 5000);
}

function setInitialStore(data) {
    var $storeElement = $('.product-detail[data-pid]');
    var searchPID = $storeElement.attr('data-pid');
    var $storeName = $storeElement.find('.selected-store-with-inventory .card-body .store-name');
    $storeName.empty();
    $storeName.text(data.storeName);
    $storeName.attr('data-store-id', data.storeID);
    $storeElement.find('.selected-store-with-inventory').closest('.row').removeClass('d-none');

    var $changeStoreButton = $storeElement.find('.change-store');
    $changeStoreButton.attr('data-postal', data.searchPostalCode);
    $changeStoreButton.attr('data-radius', data.searchRadius);

    $storeElement.find('.btn-get-in-store-inventory').closest('.row').addClass('d-none');
    $('body').trigger('product:afterAttributeSelect', { data: data, container: $('.onevariantsku').parents('.product-detail.container') });
}

exports.initBarCode = function () {
    $(document).ready(function () {
        var code = $("#barcode").data("code");
        JsBarcode("#barcode", code, {
            format: "CODE39",
            lineColor: "#000",
            displayValue: true,
            width: 1,
            height: 50,
            margin: 0,
            font: "sans-serif",
            fontSize: 14,
            fontOptions: "bold",
            textAlign: "left"
        });
    });
};

exports.setMyStoreForProduct = function() {
    $(document).ready(function () {
        const $myStore = $('.header .my-store');
        const myStoreId = $myStore.data('store-id');
        const myStoreName = $myStore.data('store-name');
        var data = {
            storeID: myStoreId,
            storeName: myStoreName,
            searchRadius: '300'
        };
        setInitialStore(data);
    });
};

$('body').on('click', '.email-notify-sign-up', function (e) {
    var $this = $(this);
    var productid = $this.data('productid');
    var userEmail = $this.data('useremail');
    var url = $this.data('actionurl');
    $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        data: {
            productid: productid,
            userEmail: userEmail
        },
        success: function (data) {
            displayMessage(data);
        },
        error: function (err) {
            displayMessage(err);
        }
    });
});

// if a product has one size variant, run the ATS store lookup for the selected or default store
// checks for 'onevariantsku' class found in availablity.isml
exports.showVariantSku = function() {
    $(document).ready(function () {
        if ($('.onevariantsku')) {
            var $productContainer = $('.onevariantsku').parents('.product-detail.container');
            var data = {
                product: {
                    id: $productContainer.attr('data-pid')
                }
            };
            $productContainer.find('button.change-store').show();
            $('body').trigger('product:afterAttributeSelect',
                { data: data, container: $productContainer });
        }
    });
};

exports.setAsPreferredStore = function () {
    $('body').on('click', '.set-as-your-store', function (e) {
        e.preventDefault();
        var $this = $(this);
        var url = $this.data('action-url');
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                if (!data.error) {
                    const yourStoreText = $this.data('your-store-text');
                    const setStoreText = $this.data('set-store-text');
                    var $oldStore = $('.is-your-store');
                    if ($oldStore.length > 0) {
                        $oldStore.each(function() {
                            $(this).toggleClass('hide is-your-store').text(setStoreText);
                        });
                    }
                    $this.toggleClass('is-your-store hide');//.text(yourStoreText);
                    var $myStoreHeader = $('header .my-store');
                    const headerLinkUrl = $myStoreHeader.first().data('store-page-url');
                    $myStoreHeader.each( function() {
                        $(this).attr('href', headerLinkUrl + '?storeID=' + data.store.id).children('.my-store--name').first().text(data.store.name);
                    });
                    
                    toastHelpers.methods.show('success', data.message, false);
                } else {
                    toastHelpers.methods.show('warning', data.message, false);
                }
            },
            error: function (data) {
                if (data.message) {
                    toastHelpers.methods.show('danger', data.message, false);
                }
            },
            complete: function (data) {
                //$('.minicart').trigger('count:update', data.responseJSON);
            }
        });
    });
};

exports.updateAvailabilityMessageClass = function() {
    $(document).ready(function () {
        let $mList = $('.availability-msg'),
        options = {
        childList: true
        },
        observer = new MutationObserver(mCallback);

        function mCallback(mutations) {
            for (let mutation of mutations) {
                if (mutation.addedNodes.length > 0) {
                    const customClass = ($mList.find('div').text()).toLowerCase().replace(/\s/g, '');
                    $mList.children('li').addClass(customClass);
                }
            }
        }

        if ($mList.length > 0 ) {
            observer.observe($mList[0], options);
        }
    });
};

module.exports = exports;
